import { MAX_NOTES_LENGTH } from "@/const";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useState } from "react";

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: (notes: string) => void;
  isLoading?: boolean;
};

export function RejectWholeEpisodeDialog({
  open,
  onClose,
  onConfirm,
  isLoading,
}: Props) {
  const [notes, setNotes] = useState<string>("");
  const [error, setError] = useState<string | null>(null);

  const handleConfirm = () => {
    if (!notes) {
      setError("Please provide notes for rejection.");
      return;
    }
    onConfirm(notes);
    setNotes("");
  };

  const handleClose = () => {
    onClose();
    setError(null);
    setNotes("");
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <DialogTitle>{"Reject Whole Story"}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Are you sure you want to reject this whole story? This will reject and
          submit the text to trigger regeneration.
        </DialogContentText>
        <TextField
          placeholder="Add any additional notes"
          label={"Notes"}
          fullWidth
          multiline
          rows={3}
          value={notes}
          onChange={(event) => {
            setError(null);
            setNotes(event.target.value);
          }}
          inputProps={{ maxLength: MAX_NOTES_LENGTH }}
          error={!!error}
          helperText={error || `${notes.length}/${MAX_NOTES_LENGTH} characters`}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          color="error"
          variant="contained"
          disabled={isLoading}
        >
          {isLoading ? "Rejecting..." : "Reject"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
